import React from 'react'
import {
  TextField as MuiTextField,
  TextFieldProps as MuiTextFieldProps,
} from '@mui/material'
import { useDispatch } from 'react-redux'

import type { Dispatch } from 'redux'
import { useAppSelector } from 'redux/Hook'
import sanitize from 'lib/HtmlSanitizer'

interface TextFieldProps extends Omit<MuiTextFieldProps, 'onChange'> {
  id?: string
  label: string
  onChange: (key: string, value: string, dispatch: Dispatch) => void
}

const TextField: React.FC<TextFieldProps> = (props) => {
  const { id, label, onChange, ...rest } = props
  const errorMessage = useAppSelector(
    (state) => state.toolBuilder.validation?.[id || label],
  )
  const dispatch = useDispatch()
  const toolState = useAppSelector(
    (state) => state.toolBuilder.toolBuilder,
  ) as Record<string, string>
  const { fetching, saving } = useAppSelector((state) => state.toolBuilder)

  return (
    <MuiTextField
      label={label}
      {...rest}
      disabled={fetching || saving}
      value={toolState[id || label] || ''}
      InputLabelProps={{ shrink: !!toolState[id || label] }}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event?.target || {}
        return onChange(name || id || label, sanitize(value).__html, dispatch)
      }}
      error={!!errorMessage}
      helperText={errorMessage}
    />
  )
}

export { TextField }

export type { TextFieldProps }
